import { getI18n } from '#/i18n/getI18n';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

type Props = {
  locale: I18nLocale;
};

export function HorizonBrowserNotSupportedScript({ locale }: Props) {
  const { i18n } = getI18n(locale);

  const alertMessage = [
    i18n(
      'Idealist has stopped supporting Internet Explorer as of Jan 1, 2021. Please use a different browser (Chrome, Firefox, Microsoft Edge, etc.).',
    ),
    i18n('Contact us at support@idealist.org if you have any questions.'),
  ].join('\\n\\n');

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
var isIE11 = typeof window !== 'undefined' && !!window.MSInputMethodContext && !!document.documentMode;

if (isIE11) alert("${alertMessage}");`,
      }}
    />
  );
}
